import React from 'react';
import { Checkbox, NoValue, } from '@folio/stripes/components';
import { FolioFormattedDate } from '@folio/stripes-acq-components';
import { CLAIMING_LIST_COLUMNS } from '../constants';
export var getResultsListFormatter = function (_a) {
    var _b;
    var disabled = _a.disabled, intl = _a.intl, onSelect = _a.onSelect, selectedRecordsDict = _a.selectedRecordsDict;
    return _b = {
            select: function (item) { return (React.createElement(Checkbox, { "aria-label": intl.formatMessage({ id: 'ui-claims.claiming.results.columns.select' }, { term: item.id }), type: "checkbox", checked: Boolean(selectedRecordsDict[item.id]), onChange: function () { return onSelect(item); }, disabled: disabled })); }
        },
        _b[CLAIMING_LIST_COLUMNS.chronology] = function (_a) {
            var chronology = _a.chronology;
            return (chronology || React.createElement(NoValue, null));
        },
        _b[CLAIMING_LIST_COLUMNS.displaySummary] = function (_a) {
            var displaySummary = _a.displaySummary;
            return displaySummary || React.createElement(NoValue, null);
        },
        _b[CLAIMING_LIST_COLUMNS.enumeration] = function (_a) {
            var enumeration = _a.enumeration;
            return enumeration || React.createElement(NoValue, null);
        },
        _b[CLAIMING_LIST_COLUMNS.poLineNumber] = function (_a) {
            var poLineNumber = _a.poLineNumber;
            return poLineNumber || React.createElement(NoValue, null);
        },
        _b[CLAIMING_LIST_COLUMNS.receiptDate] = function (_a) {
            var receiptDate = _a.receiptDate;
            return React.createElement(FolioFormattedDate, { value: receiptDate });
        },
        _b[CLAIMING_LIST_COLUMNS.receivingStatus] = function (_a) {
            var receivingStatus = _a.receivingStatus;
            return receivingStatus || React.createElement(NoValue, null);
        },
        _b[CLAIMING_LIST_COLUMNS.title] = function (_a) {
            var title = _a.title;
            return title || React.createElement(NoValue, null);
        },
        _b[CLAIMING_LIST_COLUMNS.vendorCode] = function (_a) {
            var vendorCode = _a.vendorCode;
            return vendorCode || React.createElement(NoValue, null);
        },
        _b[CLAIMING_LIST_COLUMNS.vendorName] = function (_a) {
            var vendorName = _a.vendorName;
            return vendorName || React.createElement(NoValue, null);
        },
        _b;
};
